<template>
  <header class="header">
    <div class="header-container">
      <div class="header-top">
        <a href="#" class="header-hamburger" title="Header hamburger menu" @click.prevent="isOpen = !isOpen">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" v-if="isOpen" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" v-else="" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M4 27h28v-3H4v3zm0-8h28v-3H4v3zM4 8v3h28V8H4z"/></svg>
        </a>
        <ul class="header-secondary">
          <li>
            <router-link :to="{ name: homePage }"
                         v-if="isLoggedIn">
              <span v-on:click="LOGOUT" lang="en">{{ $t("general.logout") }}</span>
            </router-link>
          </li>
          <li v-for="nav in getNavigationType('secondary')" :key="nav.name">
            <a :href="nav.link">{{ nav.title }}</a>
          </li>
        </ul>
        <router-link
        aria-label="logo"
          :to="{ name: logoPath }"
          v-if="isLoggedIn"
          class="header-logo"
          title="Rhenus Home Delivery"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 773.292 144.122" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="st0" fill="#fff" d="M90.864 73.26l40.802-38.29H91.443L50.51 73.26h40.355zM101.712 109.17l29.724-27.996H42.073l-29.93 27.997h89.569z"/><path class="st1" d="M8.21 8.21v127.674h127.674V8.21H8.21zM0 0h144.094v144.094H0V0z" fill="#fff" fill-rule="evenodd"/><path class="st0" fill="#fff" d="M268.561.028h18.182V27.28h56.62V.028h18.174v71.748h-18.174V44.573h-56.62v27.203h-18.182V.028zM466.07.028h-94.644v71.748h94.643V54.53h-76.461v-9.957h72.185V27.28h-72.185v-9.956h76.461V.028zM546.676 71.776l-54.675-49.642v49.642H473.82V.082h21.388l54.37 49.345V.027h18.183v71.749h-21.084zM670.6.028v53.329c0 10.172-8.412 18.419-18.788 18.419H594.51c-10.377 0-18.787-8.247-18.787-18.42V.029h18.181v48.56c0 3.281 2.713 5.942 6.061 5.942h46.391c3.347 0 6.06-2.66 6.06-5.942V.028H670.6zM750.573 71.776c12.547 0 22.719-9.923 22.719-22.224 0-12.3-10.172-22.272-22.719-22.272h-49.615c-2.878 0-5.211-2.288-5.211-5.11 0-2.821 2.333-4.846 5.211-4.846h69.783V.028h-70.155c-12.547 0-22.718 9.971-22.718 22.273 0 12.3 10.17 22.272 22.718 22.272H750.2c2.878 0 5.212 2.288 5.212 5.11 0 2.821-2.333 4.847-5.212 4.847h-70.818v17.246h71.19z"/><path class="st1" d="M185.726 44.618v27.158h-18.182V.028h71.204c12.547 0 22.718 9.971 22.718 22.273 0 12.3-10.171 22.317-22.718 22.317h-5.591l27.462 27.158h-25.504l-27.556-27.158h-21.833zm0-17.338v-9.956h52.501c2.805 0 5.078 2.228 5.078 4.977 0 2.75-2.273 4.979-5.078 4.979h-52.5z" fill="#fff" fill-rule="evenodd"/><path class="st0" d="M632.94 143.845c-4.585 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.771-8.579 8.356-8.579h54.331l.047 9.117h-48.497c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h48.497l-.047 8.853H632.94zM706.82 144.062v-9.145h49.365c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.451-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.889v9.182h-48.62c-2.838 0-5.406 2.062-5.406 5.156 0 2.984 2.451 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.553 14.396-14.715 14.396H706.82zM574.862 104.674h-23.52l.008 39.388h-9.823l-.007-39.363-23.5-.105v-9.119h56.842v9.199zM593.273 95.475h9.803v48.587h-9.803V95.475zM439.39 144.062v-9.145h49.366c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.452-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.888v9.182h-48.62c-2.837 0-5.405 2.062-5.405 5.156 0 2.984 2.45 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.552 14.396-14.715 14.396H439.39zM409.052 95.475h9.804v48.587h-9.804V95.475zM167.135 95.535h9.82l.007 39.367 52.08.106v9.114h-61.81l-.097-48.587zM260.931 104.588h-5.436c-2.458 0-4.395 2.028-4.395 4.462v21.48c0 2.434 1.937 4.463 4.395 4.463h34.264c2.458 0 4.396-2.03 4.396-4.463v-21.48c0-2.434-1.938-4.462-4.396-4.462h-28.828zm.064 39.257h-11.381c-4.584 0-8.357-3.81-8.357-8.58V104.05c0-4.77 3.773-8.579 8.357-8.579h46.026c4.585 0 8.357 3.81 8.357 8.58v31.215c0 4.769-3.772 8.58-8.357 8.58h-34.645zM344.378 134.993h26.865c2.458 0 4.395-2.03 4.395-4.463v-2.377c0-2.433-1.937-4.462-4.395-4.462h-23.946l.048-9.116h29.779c4.584 0 8.356 3.81 8.356 8.58v12.11c0 4.77-3.772 8.58-8.356 8.58h-46.362c-4.584 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.772-8.579 8.356-8.579l54.545.062v9.055h-48.663c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h7.734z" fill="#fff"/></svg>
        </router-link>
        <router-link aria-label="logo" :to="{ name: homePage }" v-else class="header-logo">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 773.292 144.122" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path class="st0" fill="#fff" d="M90.864 73.26l40.802-38.29H91.443L50.51 73.26h40.355zM101.712 109.17l29.724-27.996H42.073l-29.93 27.997h89.569z"/><path class="st1" d="M8.21 8.21v127.674h127.674V8.21H8.21zM0 0h144.094v144.094H0V0z" fill="#fff" fill-rule="evenodd"/><path class="st0" fill="#fff" d="M268.561.028h18.182V27.28h56.62V.028h18.174v71.748h-18.174V44.573h-56.62v27.203h-18.182V.028zM466.07.028h-94.644v71.748h94.643V54.53h-76.461v-9.957h72.185V27.28h-72.185v-9.956h76.461V.028zM546.676 71.776l-54.675-49.642v49.642H473.82V.082h21.388l54.37 49.345V.027h18.183v71.749h-21.084zM670.6.028v53.329c0 10.172-8.412 18.419-18.788 18.419H594.51c-10.377 0-18.787-8.247-18.787-18.42V.029h18.181v48.56c0 3.281 2.713 5.942 6.061 5.942h46.391c3.347 0 6.06-2.66 6.06-5.942V.028H670.6zM750.573 71.776c12.547 0 22.719-9.923 22.719-22.224 0-12.3-10.172-22.272-22.719-22.272h-49.615c-2.878 0-5.211-2.288-5.211-5.11 0-2.821 2.333-4.846 5.211-4.846h69.783V.028h-70.155c-12.547 0-22.718 9.971-22.718 22.273 0 12.3 10.17 22.272 22.718 22.272H750.2c2.878 0 5.212 2.288 5.212 5.11 0 2.821-2.333 4.847-5.212 4.847h-70.818v17.246h71.19z"/><path class="st1" d="M185.726 44.618v27.158h-18.182V.028h71.204c12.547 0 22.718 9.971 22.718 22.273 0 12.3-10.171 22.317-22.718 22.317h-5.591l27.462 27.158h-25.504l-27.556-27.158h-21.833zm0-17.338v-9.956h52.501c2.805 0 5.078 2.228 5.078 4.977 0 2.75-2.273 4.979-5.078 4.979h-52.5z" fill="#fff" fill-rule="evenodd"/><path class="st0" d="M632.94 143.845c-4.585 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.771-8.579 8.356-8.579h54.331l.047 9.117h-48.497c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h48.497l-.047 8.853H632.94zM706.82 144.062v-9.145h49.365c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.451-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.889v9.182h-48.62c-2.838 0-5.406 2.062-5.406 5.156 0 2.984 2.451 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.553 14.396-14.715 14.396H706.82zM574.862 104.674h-23.52l.008 39.388h-9.823l-.007-39.363-23.5-.105v-9.119h56.842v9.199zM593.273 95.475h9.803v48.587h-9.803V95.475zM439.39 144.062v-9.145h49.366c2.838 0 5.406-2.063 5.406-5.157 0-2.984-2.452-5.347-5.406-5.347h-35.743c-8.157 0-14.715-6.492-14.715-14.432s6.558-14.432 14.715-14.432h48.888v9.182h-48.62c-2.837 0-5.405 2.062-5.405 5.156 0 2.984 2.45 5.347 5.406 5.347h35.742c8.158 0 14.715 6.492 14.715 14.432 0 7.935-6.552 14.396-14.715 14.396H439.39zM409.052 95.475h9.804v48.587h-9.804V95.475zM167.135 95.535h9.82l.007 39.367 52.08.106v9.114h-61.81l-.097-48.587zM260.931 104.588h-5.436c-2.458 0-4.395 2.028-4.395 4.462v21.48c0 2.434 1.937 4.463 4.395 4.463h34.264c2.458 0 4.396-2.03 4.396-4.463v-21.48c0-2.434-1.938-4.462-4.396-4.462h-28.828zm.064 39.257h-11.381c-4.584 0-8.357-3.81-8.357-8.58V104.05c0-4.77 3.773-8.579 8.357-8.579h46.026c4.585 0 8.357 3.81 8.357 8.58v31.215c0 4.769-3.772 8.58-8.357 8.58h-34.645zM344.378 134.993h26.865c2.458 0 4.395-2.03 4.395-4.463v-2.377c0-2.433-1.937-4.462-4.395-4.462h-23.946l.048-9.116h29.779c4.584 0 8.356 3.81 8.356 8.58v12.11c0 4.77-3.772 8.58-8.356 8.58h-46.362c-4.584 0-8.356-3.81-8.356-8.58V104.05c0-4.77 3.772-8.579 8.356-8.579l54.545.062v9.055h-48.663c-2.458 0-4.396 2.028-4.396 4.462v21.48c0 2.434 1.938 4.463 4.396 4.463h7.734z" fill="#fff"/></svg>
        </router-link>
      </div>

      <div class="header-bottom">
        <ul class="header-primary">
          <li v-for="nav in filterNavigation(navigation, isLoggedIn, currentLocale)" :key="nav.name">
            <router-link :id="nav.title" :to="{ name: nav.name }"  :exact="nav.exactActiveLink" :lang="nav.name && nav.name.includes('faq') ? 'en' : null" >{{ nav.title }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="alert-container" v-if="!!alertMessage">
      <RhAlert
        type="info"
        @click="() => (alertMessage = '')"
      >
        {{ alertMessage }}
      </RhAlert>
    </div>
    <transition name="fade">
      <div class="header-drawer" v-if="isOpen">
        <ul class="header-drawer-navigation" @click="isOpen = false">
          <!-- Primary navigational items -->
          <li
            v-for="nav in filterNavigation(navigation, isLoggedIn, currentLocale)"
            :key="nav.name"
            class="header-drawer-item header-drawer-primary"
          >
            <router-link class="header-drawer-link" :to="{ name: nav.name }" :lang="nav.name && nav.name.includes('faq') ? 'en' : null">{{ nav.title }}</router-link>
          </li>
          <!-- Secondary links, less relevant, but necessary nevertheless -->
          <li
            v-for="nav in getNavigationType('secondary')"
            :key="nav.name"
            class="header-drawer-item header-drawer-secondary"
          >
            <a :href="nav.link">{{ nav.title }}</a>
          </li>
          <li class="header-drawer-item header-drawer-secondary" v-if="isLoggedIn">
            <router-link to="/" class="header-drawer-link">
              <span v-on:click="LOGOUT" lang="en">{{ $t("general.logout") }}</span>
            </router-link>
          </li>
        </ul>
        <!-- Footer links -->
        <div class="header-drawer-footer">
          <ul class="header-drawer-footer-list" @click="isOpen = false">
            <li v-for="footer in mobileFooter" :key="footer.name" :lang="footer.name && footer.name.includes('faq') ? 'en' : null">
              <a :href="footer.url" v-if="footer.url" target="_blank">{{
                footer.title
              }}</a>
              <router-link :to="{ name: footer.name }" v-else>{{
                footer.title
              }}</router-link>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </header>
</template>


<script lang="ts">
import { defineComponent } from "vue";
import { mapState, mapMutations, mapGetters } from "vuex";
import { getRouteName } from "@/routeConfig";
import { getLocale } from "@/i18n";
import {rmdNotifications} from "@/store/rmd-notification.store";
import { rmdFaqs } from "@/store/rmd-faq.store";

interface NavigationObject {
  name: string;
  type: string;
  main: boolean;
  title: string;
  visibilityScope: "public" | "private" | "start";
  exactActiveLink: boolean;
}

interface MobileFooterObject {
  title: string;
  name: string;
  url: string | undefined;
}

interface NavigationFunction {
  (type: string): NavigationObject[];
}

export default defineComponent({
  data() {
    return {
      isOpen: false,
      alertMessage: rmdNotifications.getNotification(getLocale()),
    };
  },

  computed: {
    currentLocale(): string {
      return getLocale();
    },
    logoPath(): string {
      return getRouteName("order");
    },
    homePage(): string {
      return getRouteName("startpage");
    },
    navigation(): NavigationObject[] {
        return [
        {
          name: getRouteName("startpage"),
          type: "primary",
          main: true,
          title: this.$t("general.startPage"),
          visibilityScope: 'start',
          exactActiveLink: true,
        },
        {
          name: getRouteName("order"),
          type: "primary",
          main: true,
          title: this.$t("general.overview"),
          visibilityScope: 'private',
          exactActiveLink: true,
        },
        {
          name: getRouteName("appointmentSelection"),
          type: "primary",
          title: this.$t("general.appointment"),
          visibilityScope: 'private',
          exactActiveLink: false,
        },
        {
          name: getRouteName("tracking"),
          type: "primary",
          title: this.allowTracking ? this.$t("general.shipmentTracking") : "",
          visibilityScope: 'private',
          exactActiveLink: true,
        },
        {
          name: getRouteName("faq"),
          type: "primary",
          title: this.$t("general.faq"),
          visibilityScope: 'public',
          exactActiveLink: true,
        },
        {
          name: getRouteName("contact"),
          type: "primary",
          title: this.$t("general.contact"),
          loginRequired: false,
          visibilityScope: 'public',
          exactActiveLink: true,
        }
      ] as NavigationObject[];
    },
    mobileFooter(): MobileFooterObject[] {
        return [
        { title: this.$t("general.impressum"), name: getRouteName("imprint"), url: undefined },
        { title: this.$t("general.privacy"), name: getRouteName("privacy"), url: undefined },
        {
          title: this.$t("general.aboutUs"),
          url:
            "https://www.rhenus.group/de/customised-supply-chain/home-delivery/",
          name: ""
        },
        { title: this.$t("general.faq"), name: getRouteName("faq"), url: undefined },
      ].filter(link => link.name !== getRouteName("faq") || rmdFaqs.hasFaqs(this.currentLocale)) as MobileFooterObject[];
    },
    getNavigationType(): NavigationFunction {
      return (type: string) =>
        type
          ? (this.navigation as NavigationObject[]).filter((nav) => nav.type === type)
          : (this.navigation as NavigationObject[]);
    },
    ...mapState(["order", "isLoggedIn", "language"]),
    ...mapGetters(["allowTracking"])
  },
  watch: {
    order() {
    }
  },
  methods: {
    ...mapMutations(["LOGOUT"]),
    isCancelled() {
        return this.order.currentStatus === 'Cancelled';
    },
    filterNavigation(arr: NavigationObject[], isLoggedIn: boolean, locale: string) {
      const isNavVisibleBasedOnLogin = (nav: NavigationObject) => {
        switch (nav.visibilityScope) {
          case "public":
            return true;
          case "private":
            return isLoggedIn;
          case "start":
            return !isLoggedIn;
          default:
            return false;
        }
      };

      if(this.isCancelled()){
        return arr.filter(nav => nav.main && isNavVisibleBasedOnLogin(nav)).filter(nav => nav.name !== getRouteName('faq') || rmdFaqs.hasFaqs(locale));
      }

      if (this.order === null || this.order.currentStatus != "Fulfilled") {
        return arr.filter((nav) => nav.type == "primary" && isNavVisibleBasedOnLogin(nav)).filter(nav => nav.name !== getRouteName('faq') || rmdFaqs.hasFaqs(locale));
      }

      return arr.filter((nav) => nav.main && isNavVisibleBasedOnLogin(nav)).filter(nav => nav.name !== getRouteName('faq') || rmdFaqs.hasFaqs(locale));
    },
  },
  mounted() {
    if (!this.allowTracking) {
      this.navigation[2].title = "";
    }
  },
});
</script>


<style lang="scss" scoped>
$color-primary-blue-transparent: transparentize(
  $color: $color-secondary-darkblue,
  $amount: 0.8,
);
$color-secondary-darkblue-transparent: transparentize(
  $color: $color-secondary-darkblue,
  $amount: 0.2,
);
$color-font: #404146;
$layout-mobile-maxwidth: 400px;

.header-drawer-link:focus {
  outline: 2px solid $color-primary-blue !important;
}

.header {
  height: 48px;
  background-color: $color-secondary-darkblue-transparent;
  top: 0;
  position: fixed;
  color: #fff;
  width: 100%;
  line-height: 1;
  z-index: 10;

  a:focus {
    outline-color: #fff;
  }

  @include fit(1080) {
    height: 120px;
  }

  &-container {
    margin: 0 auto;
    padding: 0 $layout-size-padding;
    height: 100%;
    max-width: $layout-size;
  }

  &-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    height: 100%;
    padding: 12px 12px 12px 0px;

    @include fit(1080) {
      align-items: flex-end;
      height: 68px;
      padding: 16.7px;
    }
  }

  &-hamburger {
    cursor: pointer;

    @include fit(1080) {
      display: none;
    }

    svg {
      fill: #fff;
      width: 28px;
      height: 28px;
      outline: none;
    }
  }

  &-secondary {
    list-style: none;
    display: none;
    margin-left: 1px;

    @include fit(1080) {
      display: flex;
    }

    li + li {
      margin-left: 25px;
    }
    a {
      padding: 5px 0;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  &-logo {
    fill: white;
    svg {
      height: 18px;
      outline: none;
      @include fit(1080) {
        height: 32px;
      }
    }
  }

  &-bottom {
    border-top: 2px solid rgba(255, 255, 255, 0.5);
    display: none;

    @include fit(1080) {
      display: block;
    }
  }

  &-primary {
    list-style: none;
    display: flex;
    margin-top: -2px;

    li {      

      & + li {
        margin-left: 25px;
      }

      a {
        display: block;
        padding: 18px 0 22px;
        border-top: 5px solid transparent;
        line-height: 1;
        transition: border 0.2s ease;
        &:hover,
        &.router-link-active {
          border-top: 5px solid #fff;
        }
      }
    }
  }

  &-drawer {
    padding: 20px 0;
    background-color: #fff;
    background-size: 100% 200%;
    background-repeat: no-repeat;
    transform-origin: center top;
    color: $color-secondary-darkblue;
    height: calc(100vh - 48px);
    font-weight: bold;
    display: flex;
    flex-direction: column;

    @include fit(1080) {
      display: none;
    }

    &-navigation {
      margin: auto;
      list-style: none;
      width: 100%;
    }

    &-item {
      padding: 16px 0;
      border-bottom: 1px solid $color-primary-blue-transparent;

      a {
        display: block;
        margin: 0 auto;
        max-width: $layout-mobile-maxwidth;
        padding: 0 35px;
      }
    }

    &-footer {
      color: $color-font;
      font-size: 0.85rem;
      font-weight: normal;
      margin: auto auto 0 auto;
      max-width: $layout-mobile-maxwidth;
      padding: 15px $layout-size-padding;

      &-list {
        list-style-type: none;
        display: flex;

        li + li {
          margin-left: 20px;
        }
      }
    }

    &-container {
      display: flex;
      justify-content: space-between;
      max-width: $layout-mobile-maxwidth;
      padding: 0 35px;
      margin: 0 auto;
    }
  }
}

.fade-leave-active,
.fade-enter-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.alert-container {
  padding: 10px;
}
</style>
